export const KIA_ID = 52;
export const MAX_KONFIDENCE_USED_BRANDS = 7;
export const MAX_POPULAR_BRANDS = 5;
export const popularModels = [
  {
    id: 1,
    name: 'Kia',
    ranges: ['Picanto', 'Rio', 'Seltos', 'Grand Sedona'],
  },
  {
    id: 2,
    name: 'BMW',
    ranges: ['2 Series Coupe', '3 Series Sedan'],
  },
  {
    id: 3,
    name: 'Ford',
    ranges: ['EcoSport', 'Figo'],
  },
  {
    id: 4,
    name: 'Hyundai',
    ranges: ['Accent', 'Atos', 'i20', 'Tucson'],
  },
  {
    id: 5,
    name: 'Renault',
    ranges: ['Sandero', 'Kwid', 'Duster', 'Kadjar'],
  },
  {
    id: 6,
    name: 'Suzuki',
    ranges: ['Celerio'],
  },
  {
    id: 7,
    name: 'Toyota',
    ranges: ['Etios', 'Yaris'],
  },
  {
    id: 8,
    name: 'Volkswagen',
    ranges: ['Polo Vivo Hatch', 'Polo'],
  },
];
export const priceFilterOptions = [
  {
    id: 1,
    value: '0,50000',
    isChecked: false,
    label: 'R0 - R50 000',
  },
  {
    id: 2,
    value: '50001,100000',
    isChecked: false,
    label: 'R50 001 - R100 000',
  },
  {
    id: 3,
    value: '100001,200000',
    isChecked: false,
    label: 'R100 001 - R200 000',
  },
  {
    id: 4,
    value: '200001,300000',
    isChecked: false,
    label: 'R200 001 - R300 000',
  },
  {
    id: 5,
    value: '300001,400000',
    isChecked: false,
    label: 'R300 001 - R400 000',
  },
  {
    id: 6,
    value: '400001,500000',
    isChecked: false,
    label: 'R400 001 - R500 000',
  },
  {
    id: 7,
    value: '500001,2000000',
    isChecked: false,
    label: 'R500 001 and over',
  },
];
export const mileageFilterOptions = [
  {
    id: 1,
    value: '0,50000',
    isChecked: false,
    label: '0 - 50 000 km',
  },
  {
    id: 2,
    value: '50001,100000',
    isChecked: false,
    label: '50 001 - 100 000 km',
  },
  {
    id: 3,
    value: '100001,150000',
    isChecked: false,
    label: '100 001 - 150 000 km',
  },
  {
    id: 4,
    value: '150001,200000',
    isChecked: false,
    label: '150 001 - 200 000 km',
  },
  {
    id: 5,
    value: '200000, 500000',
    isChecked: false,
    label: 'Over 200 000 km',
  },
];

export const HOME_PAGE_REQUEST_FIELDS = [
  'new_kia_car_range_title',
  'new_kia_car_range_description',
  'new_kia_specials_title',
  'new_kia_specials_description',
  'used_cars_title',
  'used_cars_description',
  'konfidence_used_cars_title',
  'konfidence_used_cars_description',
  'konfidence_used_car_specials_title',
  'konfidence_used_car_specials_description',
  'about_kia_retail',
  'new_cars_background',
  'call_to_actions.call_to_actions_id.text',
  'call_to_actions.call_to_actions_id.url',
  'call_to_actions.call_to_actions_id.type',
  'call_to_actions.call_to_actions_id.heading',
  'call_to_actions.call_to_actions_id.subheading',
  'call_to_actions.call_to_actions_id.image',
  'call_to_actions.call_to_actions_id.icon',
  'awards.awards_id.text',
  'awards.awards_id.url',
  'awards.awards_id.image',
  'awards.awards_id.description',
  'footer_call_to_action_image',
  'footer_call_to_action.text',
  'footer_call_to_action.url',
  'footer_call_to_action.type',
  'footer_call_to_action.heading',
  'footer_call_to_action.subheading',
  'footer_call_to_action.image',
  'footer_call_to_action.icon',
];

export const BANNER_SLIDER_REQUEST_FIELDS = [
  'desktop_image',
  'mobile_image',
  'terms_and_conditions',
  'heading',
  'subheading',
  'page',
  'show_call_to_action',
  'call_to_action_text',
  'call_to_action_url',
  'show_book_test_drive',
  'test_drive_range.name',
  'show_call_to_action_2',
  'call_to_action_text_2',
  'call_to_action_url_2',
  'call_to_action_position',
  'model',
  'video',
  'key_features',
  'source_code',
];

export const CORPORATE_BANNER_SLIDER_REQUEST_FIELDS = [
  'desktop_image',
  'mobile_image',
  'terms_and_conditions',
  'heading',
  'subheading',
  'page',
  'show_call_to_action',
  'call_to_action_text',
  'call_to_action_url',
  'show_book_test_drive',
  'show_call_to_action_2',
  'call_to_action_text_2',
  'call_to_action_url_2',
  'call_to_action_position',
  'video',
  'key_features',
  'cta_document',
  'cta_url'
];

export const FEATURED_ITEMS_REQUEST_FIELDS = [
  'image',
  'heading',
  'subheading',
  'page',
  'show_call_to_action',
  'call_to_action_text',
  'call_to_action_url',
];
